import { render } from "./Mosaic.vue?vue&type=template&id=7b321b54&scoped=true"
import script from "./Mosaic.vue?vue&type=script&lang=js"
export * from "./Mosaic.vue?vue&type=script&lang=js"

import "./Mosaic.vue?vue&type=style&index=0&id=7b321b54&scoped=true&lang=css"

import exportComponent from "/Users/alexmeister/Documents/minigames/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b321b54"]])

export default __exports__